import { ECountry, ELanguage } from '@portals/help-center-core';
import { useCategory } from '@/api/hooks/use-category';
import { ICategory } from '@/_types';
import { useClientEnvContext } from '@/contexts';

type TProps = {
  categoryId?: string;
  language: ELanguage;
  country: ECountry;
};

type TReturnUseMaterialCategories = {
  category?: ICategory;
  parentCategory?: ICategory;
  isLoading: boolean;
};
export const useCategoryTree = ({
  categoryId = '',
  language,
  country,
}: TProps): TReturnUseMaterialCategories => {
  const { instructionApiUrl } = useClientEnvContext();
  const { data: categoryData, isLoading: isLoadingCategory } = useCategory({
    id: categoryId,
    url: instructionApiUrl,
    language,
    country,
  });
  const { category } = categoryData || {};

  const parentCategoryId = category?.parentId || '';
  const { data: parentCategoryData, isLoading: isLoadingParentCategory } =
    useCategory({
      id: parentCategoryId,
      url: instructionApiUrl,
      country,
      language,
    });

  return {
    category,
    parentCategory: parentCategoryData?.category,
    isLoading:
      isLoadingCategory ||
      isLoadingParentCategory ||
      Boolean(categoryId && !category) ||
      Boolean(categoryId && !parentCategoryData),
  };
};
